module.exports = __webpack_public_path__ + "img/9791157231348.45f81ca2.jpg";